import { motion } from "framer-motion";
import { SubpageHeader } from "../components/SubpageHeader";
import { Reveal } from "../components/Reveal";
import { useLanguage } from "../i18n/LanguageContext";
import { useSEO, breadcrumbLd } from "../components/SEO";

export default function PrivacidadePage() {
    const { t } = useLanguage();
    useSEO({
        title: t.seo.privacidade.title,
        description: t.seo.privacidade.desc,
        jsonLd: breadcrumbLd([{ name: t.bc.home, path: "/" }, { name: t.bc.privacidade, path: "/privacidade" }]),
    });
    return (
        <div className="min-h-screen bg-[#070503] text-[#efe6d6] relative" data-testid="privacidade-page">
            <SubpageHeader />
            <motion.main
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
                className="mx-auto max-w-[820px] px-5 sm:px-10 pt-44 sm:pt-36 pb-24"
            >
                <Reveal className="text-center">
                    <p className="font-caps text-[11px] tracking-[0.35em] uppercase text-[#c9a24b]">{t.privacidade.label}</p>
                    <h1 className="font-display font-medium gold-text text-3xl sm:text-4xl tracking-[0.08em] mt-4 break-words hyphens-auto" data-testid="privacidade-title">
                        {t.privacidade.titulo}
                    </h1>
                    <div className="flex justify-center mt-4">
                        <img loading="lazy" decoding="async" src="/images/ornamento.webp" alt="" aria-hidden="true" className="w-32 opacity-90" />
                    </div>
                </Reveal>
                <div className="mt-12 space-y-8">
                    {t.privacidade.seccoes.map((s) => (
                        <Reveal key={s.title}>
                            <div data-testid={`privacidade-${s.title.slice(0, 3)}`}>
                                <h2 className="font-caps text-sm tracking-[0.15em] uppercase text-[#efe6d6]">{s.title}</h2>
                                <p className="text-sm sm:text-base font-light text-[#efe6d6]/65 leading-relaxed mt-3">{s.text}</p>
                            </div>
                        </Reveal>
                    ))}
                </div>
            </motion.main>
        </div>
    );
}
